import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import {
  vs,
  vscDarkPlus,
  solarizedlight as solarizedLight,
  tomorrow,
} from "react-syntax-highlighter/dist/cjs/styles/prism";
import { Card, CardContent, CardHeader } from "../card/Card";
import { ReactNode } from "react";
import { cn } from "../../utils";
import { Stack } from "../stack/Stack";

export interface CodeBlockProps {
  code: string;
  language:
    | "sql"
    | "yaml"
    | "markdown"
    | "json"
    | "javascript"
    | "python"
    | "typescript";
  fileName?: string;
  showLineNumbers?: boolean;
  editorTheme?: "vs" | "vsc-dark-plus" | "solarizedLight" | "tomorrow";
  theme: "light" | "dark";
  className?: string;
  titleActions?: ReactNode;
}

const Themes = { vs, "vsc-dark-plus": vscDarkPlus, solarizedLight, tomorrow };

export const CodeBlock = ({
  code,
  language,
  fileName,
  editorTheme = "vs",
  theme,
  showLineNumbers,
  className,
  titleActions,
}: CodeBlockProps): JSX.Element => {
  return (
    <Card
      className={cn(
        "al-p-0",
        "[&_.al-p-6]:al-p-0 [&_.al-pt-0]:al-pt-0",
        theme === "dark" && [
          "[&_pre]:al-bg-transparent",
          "[&_pre.language-markdown]:al-border-none",
          "[&_code]:al-bg-transparent [&_code]:al-whitespace-pre-wrap [&_code]:al-text-[13px] [&_code]:al-leading-[1.5]",
          "[&_.number]:al-mr-3",
          "[&_code.language-markdown]:al-whitespace-normal",
        ],
        theme !== "dark" && [
          "[&_pre]:al-bg-[#082247] [&_pre]:al-m-0 [&_pre]:al-rounded-lg",
          "[&_pre.language-markdown]:al-border-none",
          "[&_code]:al-bg-[#082247] [&_code]:al-whitespace-pre-wrap [&_code]:al-text-[13px] [&_code]:al-leading-[1.5]",
          "[&_.number]:al-mr-3",
          "[&_code.language-markdown]:al-whitespace-normal",
        ],
        className,
      )}
    >
      {fileName ? (
        <CardHeader>
          <Stack justify="between">
            {fileName} {titleActions}
          </Stack>
        </CardHeader>
      ) : null}
      <CardContent className={fileName ? "" : "al-pt-4"}>
        <SyntaxHighlighter
          showLineNumbers={showLineNumbers}
          language={language}
          style={Themes[editorTheme]}
        >
          {code}
        </SyntaxHighlighter>
      </CardContent>
    </Card>
  );
};

export default CodeBlock;
